import * as React from 'react';
export const linkedinSvg = React.forwardRef(function linkedinSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0077B5',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.764 6.5a2.262 2.262 0 1 1-.003 4.525A2.262 2.262 0 0 1 8.764 6.5ZM6.81 25.295h3.906V12.741H6.81v12.554ZM16.903 12.74h-3.74v12.555h3.897v-6.209c0-1.638.31-3.225 2.341-3.225 2.002 0 2.027 1.873 2.027 3.329v6.105h3.902V18.41c0-3.381-.73-5.98-4.682-5.98-1.897 0-3.17 1.04-3.69 2.027h-.055v-1.716Z',
      fill: '#FFFFFE',
    }),
  );
});
linkedinSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var linkedin = {
  category: 'brand',
  colorable: false,
  name: 'linkedin',
  svg: linkedinSvg,
};
